
import {AudioRecordSummaryModel} from './audioRecordSummary.model';
import {WithSummaryModel} from '../../../../entity/dto/plain/withSummary.model';
import {LovValueSummary} from '../../../../lov/lov-value/api/model/lovValueSummary.model';

export class AudioRecordModel extends WithSummaryModel<AudioRecordSummaryModel>{
    contents: LovValueSummary[] = [];
}
